import { askCompanyAiSupportChat } from 'api/company-ai';
import type { AskLocalLlmConversationResult } from 'utils/ask-ai-local-llm-chat';
import { askGeminiWithSystemInstruction } from 'utils/ask-ai-local-llm-chat';
import { getGeminiConnectionSnapshot } from 'hooks/useGeminiConnection';

/**
 * פנייה חד-פעמית למנוע AI עם הנחיית מערכת, עם נפילה למנוע של החברה.
 *
 * עד 5.11 כל הקוראים דרשו מפתח Gemini ב-localStorage של הדפדפן הנוכחי. מפתח
 * שנשמר במסך החיבורים נכתב גם לדפדפן וגם לשרת (מוצפן, לכל החברה), ולכן נציג
 * *אחר* — או אותו נציג בדפדפן אחר — ראה «אין חיבור» למרות שלחברה יש מפתח.
 * אותו פער בדיוק תוקן ב-1.11 בפאנל התמיכה הצף וב«שאל AI» בצ'אט.
 *
 * הסדר כאן: מפתח מקומי קודם (בלי סיבוב לשרת ובמודל שהנציג בחר), ורק בהיעדרו
 * המנוע של החברה דרך הנוד (`POST /api/ai/support-chat`), שם המפתח לא יוצא
 * מהשרת. המנוע שם נקבע לפי מה שמוגדר לחברה — לאו דווקא Gemini.
 */
export async function askAiWithSystemInstruction(params: {
  systemInstruction: string;
  userMessage: string;
  /** מודל ל-Gemini המקומי בלבד; המנוע של החברה קובע את המודל שלו בעצמו */
  model?: string;
  fallbackModel: string;
}): Promise<AskLocalLlmConversationResult> {
  const { systemInstruction, userMessage, model, fallbackModel } = params;

  const local = getGeminiConnectionSnapshot();
  if (local.connected) {
    return askGeminiWithSystemInstruction({
      apiKey: local.apiKey,
      model: model?.trim() || local.defaultModel || fallbackModel,
      systemInstruction,
      userMessage,
    });
  }

  const viaServer = await askCompanyAiSupportChat({
    systemPrompt: systemInstruction,
    turns: [{ role: 'user', content: userMessage }],
  });

  if (viaServer.ok) return { ok: true, text: viaServer.text };
  return { ok: false, error: viaServer.message };
}
